export const getUserLocaleFromLocalStorage = () => localStorage.getItem('locale');

export const setUserLocaleToLocalStorage = (locale: string) => localStorage.setItem('locale', locale);
